module.exports = __webpack_public_path__ + "img/весенние разливы 70х90.55d97d0a.jpg";